import * as actionTypes from './actionTypes';
import * as actions from './index';

export const setStatusbarMessage = (message) => {
    return dispatch => {
        dispatch({ type: actionTypes.STATUSBAR_SET_MESSAGE, message: message });
    };
};
/*
export const setStatusbarMessages = (messages) => {
    return dispatch => {
        dispatch({ type: actionTypes.STATUSBAR_SET_MESSAGES, messages: messages });
    };
};*/

export const resetStatusbarMessage = () => {
    return dispatch => {
        dispatch({ type: actionTypes.STATUSBAR_RESET_MESSAGE });
    };
};

export const setStatusbarException = (exception) => {
    return dispatch => {
        dispatch({ type: actionTypes.STATUSBAR_SET_EXCEPTION, exception: exception });
    };
};

export const resetStatusbarException = () => {
    return dispatch => {
        dispatch({ type: actionTypes.STATUSBAR_RESET_EXCEPTION });
    };
};
